var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"container",class:("ims-button ripple-outer ims-button-" + _vm.color + " ims-button-" + _vm.type + " ims-button-" + _vm.size + " btn-" + _vm.size + "  " + (_vm.classes.join(' '))),on:{"mousedown":_vm.addRipple,"click":function($event){return _vm.$emit('click')}}},[_c('transition-group',{staticClass:"ripples",attrs:{"name":"grow","tag":"div"}},_vm._l((_vm.ripples),function(ripple){return _c('div',{key:ripple.id,staticClass:"ripple",style:({
          top: ripple.top,
          left: ripple.left,
          width: ripple.width,
          height: ripple.height,
          background: _vm.rippleColor
        })})}),0),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }